/* bestbefore: — porting 1:1 del layer interattivo del mockup (sito/assets/ui.js)
   sul carrello vero di Shopify (Cart AJAX API + Section Rendering).
   Modale prodotto, drawer carrello, fly-to-cart, toast, vibrazioni. */

(function () {
  "use strict";

  var eur = function (n) { return n.toFixed(2).replace(".", ",") + " €"; };
  var VC_TIP = "Il valore commerciale è la nostra stima del prezzo a cui questo prodotto viene normalmente venduto nei negozi. Non è un prezzo che abbiamo praticato in passato: il nostro prezzo è sempre quello che vedi. I prezzi nei negozi variano.";
  var CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>';
  var BIO_LEAF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20c0-9 5-15 16-16-1 11-7 16-16 16z"/><path d="M4 20c3-6 7-10 12-12"/></svg>';
  var BB_SHIP_COST = 5.00;

  var PRODUCTS = window.BB_PRODUCTS || [];

  function bbVisual(p) {
    if (p && p.img) return '<img src="' + p.img + '" alt="' + String(p.name).replace(/"/g, "&quot;") + '" loading="lazy">';
    return "";
  }

  /* — Stato carrello: arriva dal JSON embedded nella sezione drawer — */
  function cartState() {
    var el = document.querySelector("[data-bb-cart-state]");
    if (!el) return { count: 0, total: 0, saved: 0 };
    try { return JSON.parse(el.textContent); } catch (e) { return { count: 0, total: 0, saved: 0 }; }
  }

  function renderPill() {
    var pill = document.getElementById("bb-cart-pill");
    if (!pill) return;
    var s = cartState();
    if (!s.count) { pill.hidden = true; pill.innerHTML = ""; return; }
    pill.hidden = false;
    pill.innerHTML = "Carrello · <b>" + eur(s.total / 100) + "</b>" +
      (s.saved > 0 ? '<span class="bb-cart-pill__save">stai risparmiando ' + eur(s.saved / 100) + " sul valore commerciale</span>" : "");
  }

  function bbPulseCart() {
    var pill = document.getElementById("bb-cart-pill");
    if (!pill) return;
    pill.classList.remove("pulse");
    void pill.offsetWidth;
    pill.classList.add("pulse");
  }

  /* — Refresh del drawer via Section Rendering API — */
  function refreshDrawer(cb) {
    fetch("/?sections=bb-cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j["bb-cart-drawer"];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newBody = doc.getElementById("bbCartBody");
        var curBody = document.getElementById("bbCartBody");
        if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
        var newState = doc.querySelector("[data-bb-cart-state]");
        var curState = document.querySelector("[data-bb-cart-state]");
        if (newState && curState) curState.textContent = newState.textContent;
        renderPill();
        if (cb) cb();
      })
      .catch(function () {});
  }

  function cartAdd(variantId, qty, done) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(done); })
      .catch(function () {});
  }

  function cartChange(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(); })
      .catch(function () {});
  }

  function cartSetQty(variantId, qty, done) {
    var updates = {};
    updates[variantId] = qty;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(done); })
      .catch(function () {});
  }

  function cartQtyOf(variantId, cb) {
    fetch("/cart.js").then(function (r) { return r.json(); })
      .then(function (c) {
        var q = 0;
        (c.items || []).forEach(function (it) { if (String(it.variant_id) === String(variantId)) q += it.quantity; });
        cb(q);
      })
      .catch(function () { cb(0); });
  }

  /* — Drawer open/close — */
  function bbOpenCart() {
    var ov = document.getElementById("bbCart");
    if (!ov) return;
    ov.hidden = false;
    document.body.style.overflow = "hidden";
    ov.classList.add("on");
  }
  function bbCloseCart() {
    var ov = document.getElementById("bbCart");
    if (!ov || ov.hidden) return;
    ov.classList.remove("on");
    document.body.style.overflow = "";
    setTimeout(function () { ov.hidden = true; }, 320);
  }
  window.bbCloseCart = bbCloseCart;

  /* — Fly to cart — */
  function bbFlyToCart(srcEl, p) {
    var pill = document.getElementById("bb-cart-pill");
    if (!pill || pill.hidden || !srcEl) return;
    var from = srcEl.getBoundingClientRect(), to = pill.getBoundingClientRect();
    var fly = document.createElement("div");
    fly.className = "bb-fly";
    fly.innerHTML = p ? bbVisual(p) : "";
    fly.style.left = (from.left + from.width / 2 - 26) + "px";
    fly.style.top = (from.top + from.height / 2 - 26) + "px";
    document.body.appendChild(fly);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);
      fly.style.transform = "translate(" + dx + "px, " + dy + "px) scale(.18)";
      fly.style.opacity = "0";
    }); });
    setTimeout(function () { fly.remove(); }, 750);
  }

  /* — Toast — */
  var bbToastT;
  function bbToast(html) {
    var t = document.querySelector(".bb-toast");
    if (!t) { t = document.createElement("div"); t.className = "bb-toast"; document.body.appendChild(t); }
    t.innerHTML = html;
    requestAnimationFrame(function () { t.classList.add("on"); });
    clearTimeout(bbToastT);
    bbToastT = setTimeout(function () { t.classList.remove("on"); }, 2600);
  }

  function bbAddToCart(qty, p, srcEl) {
    qty = qty || 1;
    if (navigator.vibrate) navigator.vibrate(15);
    if (srcEl) { srcEl.classList.remove("bb-pop"); void srcEl.offsetWidth; srcEl.classList.add("bb-pop"); }
    if (p) bbFlyToCart(srcEl, p);
    var variantId = p ? p.variantId : null;
    if (!variantId) return;
    cartAdd(variantId, qty, function () {
      setTimeout(function () {
        bbPulseCart();
        if (p) {
          var saved = (p.was - p.now) * qty;
          if (saved > 0) bbToast("Nel carrello. Risparmi <b>" + eur(saved) + "</b> sul valore commerciale.");
          else bbToast("Nel carrello.");
        } else bbToast("Nel carrello.");
      }, p ? 500 : 0);
    });
  }

  /* — Widget acquisto (T2, proposta 4D): CTA «+ Aggiungi al carrello» che al
     primo tap si trasforma nella barra stepper · carrello+badge · totale.
     Agisce direttamente sul carrello; usato dalla modale e dalla pagina prodotto. — */
  var CART_ICO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 4h2.2l2.3 11.2a1.6 1.6 0 0 0 1.6 1.3h7.9a1.6 1.6 0 0 0 1.6-1.3L20 8H6"/><circle cx="9.4" cy="20.4" r="1.4"/><circle cx="16.9" cy="20.4" r="1.4"/></svg>';
  function bbBuyHTML() {
    return '<div class="bb-buy noanim" data-s="0" data-bb-buy>' +
      '<button type="button" class="bb-buy__cta" data-cta><span class="pl">+</span> Aggiungi al carrello ' + CART_ICO + "</button>" +
      '<div class="bb-buy__bar">' +
        '<span class="bb-buy__step">' +
          '<button type="button" data-q="-1" aria-label="Togli uno dal carrello">−</button>' +
          '<span data-qty>0</span>' +
          '<button type="button" data-q="1" aria-label="Aggiungi uno al carrello">+</button>' +
        "</span>" +
        '<button type="button" class="bb-buy__cart" data-opencart aria-label="Apri il carrello">' + CART_ICO + '<span class="bb-buy__badge" data-n>0</span></button>' +
        '<span class="bb-buy__tot" aria-live="polite"><b>Totale <span data-tot></span></b><small data-savetxt></small></span>' +
      "</div>" +
    "</div>";
  }
  function popEl(el) { if (!el) return; el.classList.remove("pop"); void el.offsetWidth; el.classList.add("pop"); }
  function bbBuyInit(root, p) {
    if (!root || !p) return;
    var qty = 0;
    var unit = p.was > p.now ? p.was - p.now : 0;
    var max = p.stock || 99;
    var val = root.querySelector("[data-qty]");
    var badge = root.querySelector("[data-n]");
    var tot = root.querySelector("[data-tot]");
    var save = root.querySelector("[data-savetxt]");
    function refresh(dir) {
      root.dataset.s = qty > 0 ? "1" : "0";
      val.textContent = qty;
      badge.textContent = qty;
      tot.textContent = eur(p.now * qty);
      save.innerHTML = unit > 0 ? "Risparmi <b>" + eur(unit * qty) + "</b> sul valore commerciale" : "Nel carrello";
      if (dir) { popEl(val); popEl(badge); }
    }
    function change(d, srcEl) {
      var next = Math.max(0, Math.min(max, qty + d));
      if (next === qty) return;
      qty = next;
      refresh(d);
      if (navigator.vibrate) navigator.vibrate(10);
      root.classList.remove("shake"); void root.offsetWidth; root.classList.add("shake");
      if (d > 0) {
        bbFlyToCart(srcEl, p);
        cartAdd(p.variantId, 1, function () { bbPulseCart(); });
      } else {
        cartSetQty(p.variantId, qty, function () { bbPulseCart(); });
      }
    }
    refresh(0);
    cartQtyOf(p.variantId, function (q) {
      qty = q; refresh(0);
      setTimeout(function () { root.classList.remove("noanim"); }, 60);
    });
    root.querySelector("[data-cta]").addEventListener("click", function (e) { change(1, e.currentTarget); });
    root.querySelectorAll("[data-q]").forEach(function (b) {
      b.addEventListener("click", function () { change(+b.dataset.q, b); });
    });
    root.querySelector("[data-opencart]").addEventListener("click", function () { bbOpenCart(); });
  }

  /* — Modale prodotto — */
  function bbModalMainHTML(p) {
    var low = p.stock > 0 && p.stock <= 15;
    var descHtml = p.desc && p.desc.indexOf("<") >= 0 ? p.desc : (p.desc || "").replace(/\n/g, "<br>");
    return '<div class="bb-modal-main">' +
      '<div class="bb-modal-art">' +
        (p.off > 0 ? '<span class="bb-badge">−' + p.off + "%</span>" : "") +
        bbVisual(p) +
      "</div>" +
      '<div class="bb-modal-info">' +
        '<div class="bb-modal-brand">' + (p.vendor || "") + "</div>" +
        "<h2>" + p.name + "</h2>" +
        (p.denom || p.qty ? '<p class="bb-pdp__denom">' + (p.denom || "") + (p.denom && p.qty ? " · " : "") + (p.qty ? "<b>" + p.qty + "</b>" : "") + "</p>" : "") +
        '<div class="bb-modal-tags">' +
          (p.exp ? '<span class="bb-exp ' + (p.hot ? "bb-exp--hot" : p.warm ? "bb-exp--warm" : "") + '">' + CAL + " " + p.exp + "</span>" : "") +
          (low ? '<span class="bb-exp bb-exp--hot">Solo ' + p.stock + " pezzi</span>" : "") +
          (p.bio ? '<span class="bb-bio-pill bb-bio-pill--pdp">' + BIO_LEAF + "Biologico</span>" : "") +
        "</div>" +
        '<div class="bb-modal-pricerow">' +
          '<div class="bb-price"><span class="bb-price__now">' + eur(p.now) + "</span>" + (p.off > 0 ? '<span class="bb-price__was">' + eur(p.was) + "</span>" : "") + "</div>" +
          (p.was > p.now ? '<span class="bb-modal-save">Risparmi ' + eur(p.was - p.now) + " sul valore commerciale</span>" : "") +
        "</div>" +
        (p.alcohol ? '<p class="bb-alcol"><b>Bevanda alcolica, ' + p.alcohol + '</b><br>La vendita di bevande alcoliche è vietata ai minori di 18 anni.</p>' : "") +
        (p.available ? bbBuyHTML() : "") +
        (p.desc ? '<div class="bb-pdp__desc bb-pdp__lead">' + descHtml + "</div>" : "") +
        (p.story ? '<div class="bb-modal-why"><b>Perché è su Bestbefore</b><p>' + p.story.replace(/\n/g, "<br>") + "</p></div>" : "") +
        bbModalAccsHTML(p, descHtml) +
        '<div class="bb-modal-meta">' +
          (p.was > p.now ? '<div><span>Valore commerciale<span class="bb-info" tabindex="0" role="note" aria-label="Cos\'è il valore commerciale">i<span class="bb-tip">' + VC_TIP + "</span></span></span><b>" + eur(p.was) + " <em>−" + p.off + "%</em>" + (p.perKg ? ' <span class="bb-perunit">(' + p.perKg + ")</span>" : "") + "</b></div>" :
            (p.perKg ? "<div><span>Prezzo</span><b>" + eur(p.now) + ' <span class="bb-perunit">(' + p.perKg + ")</span></b></div>" : "")) +
        "</div>" +
      "</div>" +
    "</div>";
  }

  /* Sezioni a fisarmonica della modale: stesse della scheda prodotto (BW-016), tutto in pagina, nessun rimando alla scheda. */
  function bbNutriHTML(t) {
    return '<table class="bb-nutri">' + t.split("\n").map(function (l) {
      l = l.trim(); if (!l) return "";
      var i = l.indexOf(":");
      if (i < 0) return '<tr class="head"><th colspan="2">' + l + "</th></tr>";
      var k = l.slice(0, i).trim(), v = l.slice(i + 1).trim();
      /* 23/10/2026: valore lungo (testo, non numero) → etichetta su una riga e testo a capo sotto, come in bb-prodotto.liquid. */
      if (v.length > 40) return '<tr class="head long"><th colspan="2">' + k + '</th></tr><tr class="long"><td colspan="2">' + v + "</td></tr>";
      return "<tr" + (/di cui/i.test(k) ? ' class="sub"' : "") + "><th>" + k + "</th><td>" + v + "</td></tr>";
    }).join("") + "</table>";
  }
  function bbModalAccsHTML(p, descHtml) {
    var nl = function (t) { return String(t).replace(/\n/g, "<br>"); };
    var h = function (t) { return '<h4 class="bb-acc__h">' + t + "</h4>"; };
    var acc = function (title, body, open) { return '<details class="bb-acc"' + (open ? " open" : "") + "><summary>" + title + '</summary><div class="bb-acc__body">' + body + "</div></details>"; };
    /* Bollino bio (Ivan 23/10/2026, proposta C): codice dell'organismo e origine (BL-022) qui, sotto il TMC. */
    var top = (p.expFmt ? '<div><span>Termine minimo di conservazione</span><b>' + p.expFmt + "</b></div>" : "") +
      (p.bio ? '<div><span>Organismo di controllo</span><b>' + p.bio.code + "</b></div>" + (p.bio.orig ? '<div><span>Origine delle materie prime</span><b>' + p.bio.orig + "</b></div>" : "") : "");
    var prod = (top ? '<div class="bb-pdp__meta">' + top + "</div>" : "") +
      (p.ingredients ? h("Ingredienti e allergeni") + "<p>" + nl(p.ingredients) + '</p><p class="bb-pdp__note">Gli allergeni sono evidenziati come in etichetta.</p>' : "") +
      (p.nutri ? h("Valori nutrizionali") + bbNutriHTML(p.nutri) : "") +
      (p.istr ? h("Istruzioni per l'uso") + "<p>" + nl(p.istr) + "</p>" : "");
    var meta = (p.oper ? "<div><span>Produttore</span><b>" + nl(p.oper) + "</b></div>" : "") +
      (p.orig ? "<div><span>Origine</span><b>" + p.orig + "</b></div>" : "") +
      (p.alcohol ? "<div><span>Titolo alcolometrico</span><b>" + p.alcohol + "</b></div>" : "") +
      '<div><span>Resi</span><b><a href="/policies/refund-policy">Politica di reso</a></b></div>' +
      (window.BB_GARANZIA_URL ? '<div><span>Garanzia legale</span><b><a href="' + window.BB_GARANZIA_URL + '" target="_blank" rel="noopener">Avviso ufficiale sulla garanzia legale</a></b></div>' : "");
    return '<div class="bb-accs">' +
      (prod ? acc("Il prodotto", prod) : "") +
      acc("Conservazione, produttore, consegna, resi e garanzia", (p.cons ? h("Conservazione") + "<p>" + nl(p.cons) + "</p>" : "") + '<div class="bb-pdp__meta">' + meta + "</div>") +
      "</div>";
  }

  function bbModalRelHTML(p, i) {
    var same = [], rest = [];
    PRODUCTS.forEach(function (q, j) {
      if (j === i) return;
      (q.brand && q.brand === p.brand ? same : rest).push(j);
    });
    return same.concat(rest).map(function (j) {
      var q = PRODUCTS[j];
      var expChip = q.exp ? '<span class="' + (q.hot ? "bb-exp bb-exp--hot" : q.warm ? "bb-exp bb-exp--warm" : "bb-exp") + '">' + CAL + " " + q.exp + "</span>" : "";
      if (q.alcohol) expChip += '<span class="bb-exp bb-exp--alc">Vietata ai minori di 18 anni</span>';
      return '<article class="bb-card" data-pi="' + j + '" tabindex="0" role="button" aria-label="Apri scheda di ' + String(q.name).replace(/"/g, "&quot;") + '">' +
        '<div class="bb-card__art">' + (q.off > 0 ? '<span class="bb-badge">−' + q.off + "%</span>" : "") + bbVisual(q) + "</div>" +
        '<div class="bb-card__body">' + expChip +
          (q.vendor ? '<div class="bb-card__brand">' + q.vendor + "</div>" : "") +
          '<h3 class="bb-card__name">' + q.name + "</h3>" +
          '<div class="bb-card__row"><div class="bb-price"><span class="bb-price__now">' + eur(q.now) + "</span>" + (q.off > 0 ? '<span class="bb-price__was">' + eur(q.was) + "</span>" : "") + "</div>" +
          (q.available ? '<button class="bb-add" type="button" aria-label="Aggiungi ' + String(q.name).replace(/"/g, "&quot;") + '">+</button>' : "") +
          "</div></div></article>";
    }).join("");
  }

  function bbOpenModal(i) {
    var p = PRODUCTS[i];
    var ov = document.getElementById("bbModal");
    if (!p || !ov) return;
    var body = document.getElementById("bbModalBody");
    body.innerHTML = bbModalMainHTML(p);
    var rel = document.getElementById("bbModalRel");
    if (rel) rel.innerHTML = bbModalRelHTML(p, i);
    ov.hidden = false;
    document.body.style.overflow = "hidden";
    ov.scrollTop = 0;
    history.replaceState(null, "", "#p" + i);
    bbBuyInit(body.querySelector("[data-bb-buy]"), p);
  }
  window.bbOpenModal = bbOpenModal;

  function bbCloseModal() {
    var ov = document.getElementById("bbModal");
    if (!ov || ov.hidden) return;
    ov.hidden = true;
    document.body.style.overflow = "";
    history.replaceState(null, "", location.pathname);
  }
  window.bbCloseModal = bbCloseModal;

  /* — Delegazione click (porta i listener del mockup) — */
  document.addEventListener("click", function (e) {
    /* + sulla card (griglia o correlati del modale) */
    var add = e.target.closest(".bb-add");
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      if (navigator.vibrate) navigator.vibrate(12);
      add.classList.remove("shake"); void add.offsetWidth; add.classList.add("shake");
      var card = add.closest(".bb-card");
      var p = card && card.dataset.pi != null && card.dataset.pi !== "" ? PRODUCTS[+card.dataset.pi] : null;
      bbAddToCart(1, p, card || add);
      return;
    }

    /* stepper del drawer */
    var step = e.target.closest("[data-cart-key][data-q]");
    if (step) {
      if (navigator.vibrate) navigator.vibrate(10);
      var span = step.parentElement.querySelector("span");
      var cur = span ? parseInt(span.textContent, 10) || 0 : 0;
      cartChange(step.dataset.cartKey, Math.max(0, cur + parseInt(step.dataset.q, 10)));
      return;
    }

    /* pill carrello → drawer */
    var pill = e.target.closest("#bb-cart-pill");
    if (pill) { e.preventDefault(); bbOpenCart(); return; }

    /* chiusure drawer */
    if (e.target.closest("[data-bb-cart-close]")) { bbCloseCart(); return; }
    var cartOv = document.getElementById("bbCart");
    if (cartOv && !cartOv.hidden && e.target === cartOv) { bbCloseCart(); return; }

    /* chiusure modale */
    if (e.target.closest(".bb-modal-close")) { bbCloseModal(); return; }
    if (e.target.closest("[data-bb-buy]")) return;
    var modOv = document.getElementById("bbModal");
    if (modOv && !modOv.hidden && e.target === modOv) { bbCloseModal(); return; }

    /* click sulla card → modale (solo dove esiste BB_PRODUCTS) */
    var cardEl = e.target.closest(".bb-card");
    if (cardEl && cardEl.dataset.pi != null && cardEl.dataset.pi !== "" && PRODUCTS.length) {
      e.preventDefault();
      bbOpenModal(+cardEl.dataset.pi);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { bbCloseModal(); bbCloseCart(); }
    if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches(".bb-card")) {
      e.preventDefault();
      if (e.target.dataset.pi != null && PRODUCTS.length) bbOpenModal(+e.target.dataset.pi);
    }
  });

  /* — Pagina prodotto: stesso widget della modale, montato nel placeholder della sezione — */
  document.querySelectorAll("[data-bb-buy-mount]").forEach(function (m) {
    if (PRODUCTS.length !== 1) return;
    m.innerHTML = bbBuyHTML();
    bbBuyInit(m.querySelector("[data-bb-buy]"), PRODUCTS[0]);
  });

  /* deep link: #p3 apre il modale del prodotto 3 */
  if (/^#p\d+$/.test(location.hash) && PRODUCTS.length) bbOpenModal(+location.hash.slice(2));

  /* — Ricerca (Ivan 23/10/2026): niente pagina dei risultati. Il campo della topbar filtra in tempo reale
     la griglia marcata data-bb-search-grid (home, reparti) sul data-q delle card (titolo, marca, reparto,
     collezioni, etichette), senza maiuscole né accenti; ogni parola scritta deve esserci. Nessun risultato →
     riga data-bb-search-empty con i reparti. Senza griglia il form va da sé a /collections/all?q=, dove il
     filtro si applica al caricamento (q letto dall'URL). — */
  (function () {
    var form = document.querySelector("form[data-bb-search]");
    var input = form && form.querySelector("input[name=q]");
    if (!input) return;
    var grid = document.querySelector("[data-bb-search-grid]");
    if (!grid) {
      form.addEventListener("submit", function (e) { if (!input.value.trim()) e.preventDefault(); });
      return;
    }
    var fold = function (s) {
      s = String(s || "").toLowerCase();
      return s.normalize ? s.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : s;
    };
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".bb-card"));
    var hay = cards.map(function (c) { return fold(c.dataset.q || c.textContent); });
    var empty = document.querySelector("[data-bb-search-empty]");
    var term = empty && empty.querySelector("[data-bb-search-term]");
    var sec = document.getElementById("bb-spesa") || grid.closest(".bb-grid-section") || grid;

    function apply() {
      var raw = input.value.trim();
      var words = fold(raw).split(/\s+/).filter(Boolean);
      var shown = 0;
      cards.forEach(function (c, i) {
        var ok = words.every(function (w) { return hay[i].indexOf(w) >= 0; });
        c.classList.toggle("bb-card--q-off", !ok);
        if (ok && c.style.display !== "none") shown++;
      });
      if (empty) {
        if (term) term.textContent = raw;
        empty.hidden = !(words.length && shown === 0);
      }
      if (window.history && history.replaceState && window.URL) {
        var u = new URL(location.href);
        if (raw) u.searchParams.set("q", raw); else u.searchParams.delete("q");
        history.replaceState(null, "", u.pathname + u.search + u.hash);
      }
    }
    /* la griglia sotto la piega (home: c'è l'hero sopra) si porta in vista */
    function reveal() {
      var r = sec.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.7 || r.bottom < 0) sec.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    input.addEventListener("input", function () { apply(); if (input.value.trim()) reveal(); });
    input.addEventListener("search", apply);
    form.addEventListener("submit", function (e) { e.preventDefault(); apply(); reveal(); input.blur(); });
    /* chip e sidebar della home nascondono le card con display: conteggio da rifare */
    document.addEventListener("click", function (e) {
      if (e.target.closest(".bb-chip, .bb-side__item")) setTimeout(apply, 0);
    });
    var q0 = new URLSearchParams(location.search).get("q");
    if (q0) { input.value = q0; apply(); }
  })();

  renderPill();
})();
